module.exports = __webpack_public_path__ + "img/Coresi_Pravila_1560-1562_f7.08d9410b.png";